e4.product = {
    debug: true,
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                e4.product.variants.init();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
        if ( jQuery( '.js-e-product-favorite-list-form' ).length > 0 ) {
            e4.product.favoritelist.bindEvents();
        }
        if(jQuery('.js-tvilum-product-specifications-btn').length > 0){
            e4.product.specifications.bindEvents();
        }
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    },
    favoritelist: {
        bindEvents: function () {
            jQuery( '.js-e-product-favorite-list-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
            } ).on( 'change', '.js-e-favorite-list', function ( event ) {
                e4.product.favoritelist.toggleList( event.target );
            } );
        },
        toggleList: function ( domInput ) {
            var jInput = jQuery( domInput );
            if ( jInput.prop( 'checked' ) === true ) {
                e4.product.favoritelist.addToList( jInput );
            }
            else {
                e4.product.favoritelist.removeFromList( jInput );
            }
        },
        addToList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-add' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        },
        removeFromList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-remove' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        }
    },
    specifications: {
        lastObjProductData: null,
        bindEvents: function(){
            jQuery('#tvilumSpecifications').on('show.bs.modal', function (event) {
                var objProductData = {
                    ProductID: jQuery(event.target).data('productid'),
                    VariantID: jQuery(event.target).data('variantid'),
                    q: jQuery('#tvilum-product-details-search-input').val()
                };
                e4.product.specifications.build(objProductData);
            });

            jQuery('#tvilumSpecifications').on('click', '#tvilum-product-details-search-btn', function ( event ) {
                var objProductData = {
                    ProductID: jQuery('#tvilumSpecifications').data('productid'),
                    VariantID: jQuery('#tvilumSpecifications').data('variantid'),
                    q: jQuery('#tvilum-product-details-search-input').val()
                };
                e4.product.specifications.build(objProductData);
            });
            jQuery('#tvilumSpecifications').on('click', '.js-tvilum-product-details-search-clear', function( event ){
                jQuery('#tvilum-product-details-search-input').val('');
                jQuery('#tvilumSpecifications').find('#tvilum-product-details-search-btn').trigger('click');
                jQuery('#tvilumSpecifications').find('#tvilum-product-details-search-input').trigger('keyup');
            });

            jQuery('#tvilumSpecifications').on('keyup', '#tvilum-product-details-search-input', function( event ){
                var jElement = jQuery(event.target);
                if(jElement.val().length > 0) {
                    jElement.closest('.e-search-input-group').removeClass('is-empty');
                } else {
                    jElement.closest('.e-search-input-group').addClass('is-empty');
                }
                if(event.keyCode === 13){
                    jQuery('#tvilumSpecifications').find('#tvilum-product-details-search-btn').trigger('click');
                }
            });
            jQuery('#tvilumSpecifications').on('click', '.js-scroll-to-specifications', function( event ){
                event.preventDefault();
                jQuery('#tvilumSpecifications').find('.js-scroll-to-specifications').closest('li').removeClass('active');
                jQuery(event.target).closest('li').addClass('active');
                jQuery('.js-scroll-container').animate({
                    scrollTop: jQuery(event.target.hash)[0].offsetTop
                }, e4.header.hide);
            });
        },
        build: function ( objProductData ){
            if(e4.product.specifications.lastObjProductData != objProductData){
                e4.product.specifications.ajax( {
                    method: 'GET',
                    data: objProductData
                }, function ( data ) {
                    jQuery('#tvilumSpecifications').find( '.js-tvilum-product-specifications-modal-container' ).html( e4.handlebars.tmpl.tvilumProductSpecificationsModal( data ) );
                    jQuery( '.js-tvilum-product-specifications-modal' ).find('.js-e-loading-overlay').removeClass( 'is-loading' );
                    e4.product.specifications.lastObjProductData = objProductData;
                } );
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                    url: e4.settings.ecom.specifications.url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    beforeSend: function () {
                        jQuery( '.js-tvilum-product-specifications-modal' ).find('.js-e-loading-overlay').addClass( 'is-loading' );

                    }
                }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        }
    }
};
